import * as O from 'fp-ts/lib/Option';
import {ofType, unionize, UnionOf} from 'unionize';
import {ToMatchOptions} from '../../Shared/utilities/MapDiscriminatedUnion';
export type EmptyValue = '';

export const toFormattedInequalityRange = (inequalityRange: InequalityRange) => {
  const {operator, operand} = inequalityRange;

  const operatorSymbol =
    operator === '2' ? 'Greater Than' : operator === '3' ? 'Less Than' : operator === '1' ? 'Equal To' : '?';

  return `${operatorSymbol} ${operand || '?'}`;
};

export class IncompleteInequalityRange {
  public readonly key = 'IncompleteInequalityRange';

  constructor(public readonly operator: string, public readonly operand: string) {}
}

export class CompleteInequalityRange {
  public static create(operator: string, operand: string) {
    return operator !== '' && operand !== ''
      ? new CompleteInequalityRange(operator, operand)
      : new IncompleteInequalityRange(operator, operand);
  }

  public readonly key = 'CompleteInequalityRange';
  private constructor(public readonly operator: string, public readonly operand: string) {}
}

export const isValidInequalityRange = (value: InequalityRange): value is CompleteInequalityRange =>
  value.key === 'CompleteInequalityRange';
export type InequalityRange = IncompleteInequalityRange | CompleteInequalityRange;
export type InequalityRangeFilter = O.Option<CompleteInequalityRange>;
export type InequalityRangeFilterIncomplete = O.Option<IncompleteInequalityRange>;

export type InequalityOptions<TReturn> = ToMatchOptions<InequalityRange, 'key', TReturn>;

export const InequalityFilterOptionValue = unionize({
  CompleteInequality: ofType<CompleteInequalityRange>(),
  IncompleteInequality: ofType<IncompleteInequalityRange>(),
});

export type InequalityFilterOptionUnion = UnionOf<typeof InequalityFilterOptionValue>;
